import type { ReactNode } from 'react';

const PLATFORM_NAME = import.meta.env.VITE_PLATFORM_NAME || 'LeadDesk';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-surface-muted px-4 py-10">
      <div className="mb-6 flex items-center gap-2">
        <div
          aria-hidden
          className="flex size-9 items-center justify-center rounded-lg bg-brand-600 text-lg font-bold text-white"
        >
          L
        </div>
        <span className="text-lg font-semibold text-fg">{PLATFORM_NAME}</span>
      </div>
      <main className="w-full max-w-sm rounded-xl border border-line bg-surface p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-fg">{title}</h1>
        {subtitle ? <p className="mt-1 text-sm text-fg-muted">{subtitle}</p> : null}
        <div className="mt-6">{children}</div>
      </main>
      {footer ? <div className="mt-4 text-sm text-fg-muted">{footer}</div> : null}
    </div>
  );
}

/** Reads a one-time token from the URL fragment and removes it from the address bar. */
export function takeFragmentToken(): string | null {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const token = params.get('token');
  if (token) window.history.replaceState(null, '', window.location.pathname);
  return token;
}
